var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapMarkerRequisitionPickupCompleted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "52px",
    viewBox: "0 0 30 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "map-marker-requisition-pickup-completed") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Map-Marker-/-Requisition-Pickup-Completed"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5558495,0.72207525 C14.5186165,-0.24069175 15.4813835,-0.24069175 16.4441505,0.72207525 L16.4441505,0.72207525 L23.3953557,7.67328042 C24.0183226,8.29624731 24.1599059,9.03248089 23.8201058,9.88198119 C23.4803057,10.7314815 22.8573388,11.1562316 21.9512052,11.1562316 L21.9512052,11.1562316 L19.1164021,11.1562316 L19.1168091,12.5636952 C25.3994789,14.3270116 30,20.0253418 30,26.7826087 C30,32.2254149 25,40.631212 15,52 C5,40.631212 0,32.2254149 0,26.7826087 C0,20.0253418 4.60052108,14.3270116 10.8831909,12.5636952 L10.8835979,11.1562316 L8.04879483,11.1562316 C7.14266118,11.1562316 6.5196943,10.7314815 6.17989418,9.88198119 C5.84009406,9.03248089 5.98167744,8.29624731 6.60464433,7.67328042 L6.60464433,7.67328042 Z",
    id: "Combined-Shape",
    fill: "#44D784"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#1F5BC0",
    cx: 15,
    cy: 27,
    r: 11
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerRequisitionPickupCompleted);
export default __webpack_public_path__ + "static/media/map-marker-requisition-pickup-completed.efd4f8b9a705065ba852c9dceb89fcda.svg";
export { ForwardRef as ReactComponent };